const wall = [
	{
		path: '/network/wall/categories/list',
		name: 'wall-categories-list',
		component: () => import('@/views/network/wall/categories/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,wall',
		},
	},
	{
		path: '/network/wall/maps/list',
		name: 'wall-maps-list',
		component: () => import('@/views/network/wall/maps/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,wall',
		},
	},
	{
		path: '/network/wall/rewards/list',
		name: 'wall-rewards-list',
		component: () => import('@/views/network/wall/rewards/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,wall',
		},
	},
	{
		path: '/network/wall/blocks/list',
		name: 'wall-blocks-list',
		component: () => import('@/views/network/wall/blocks/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,wall',
		},
	},
	{
		path: '/network/wall/grants/list',
		name: 'wall-grants-list',
		component: () => import('@/views/network/wall/grants/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,wall',
		},
	},
]

export default wall
